import { render, staticRenderFns } from "./faceSecondAndroid.vue?vue&type=template&id=0867ac20&scoped=true"
import script from "./faceSecondAndroid.vue?vue&type=script&lang=js"
export * from "./faceSecondAndroid.vue?vue&type=script&lang=js"
import style0 from "./faceSecondAndroid.vue?vue&type=style&index=0&id=0867ac20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867ac20",
  null
  
)

export default component.exports